import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/auth";
import { formatDate, add_shift_attributes } from "../requests/utilities/helpers";
import { formatDateReadableWithDayOfWeekNoYear } from "../requests/utilities/helpers";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import PauseIcon from "@mui/icons-material/Pause";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import TimeClockShiftCard from "./TimeClockShiftCard";
import TimeClockUnscheduledShiftCard from "./TimeClockUnscheduledShiftCard";
import TimeClockShiftSummaryModal from "./TimeClockShiftSummaryModal";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import TimeClockExitAppWarningModal from "./TimeClockExitAppModal";
import TimeClockRoleSelectionModal from "./TimeClockRoleSelectionModal";
import { get_t_str, normalizePaidBreaks } from "../../../helpers/helpers";
import {
  API_post_timecard_clock_in,
  API_post_timecard_clock_out,
  API_post_timecard_break_clock_in,
  API_post_timecard_break_clock_out,
  API_get_capable_roles,
} from "../../../constants";
import { postRightworkAPI } from "../requests/utilities/requests";
import { getRightworkAPI } from "../requests/utilities/requests";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function TimeClockContents(props) {

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [openExitAppWarning, setOpenExitApp] = React.useState(false);
  const handleOpenExitAppWarning = () => setOpenExitApp(true);
  const handleCloseExitAppWarning = () => setOpenExitApp(false);


  const [openRoleSelection, setOpenRoleSelection] = React.useState(false);
  const handleOpenRoleSelection = () => setOpenRoleSelection(true);
  const handleCloseRoleSelection = () => setOpenRoleSelection(false);


  const employeeClockData = props.employeeClockData;
  const isLoading = props.isLoading;

  // console.log("DATA", employeeClockData)

  const [clockOutTimeForSummaryModal, setClockOutTimeForSummaryModal] =
    React.useState(null);
  const [showClockOutForSummaryModal, setShowClockOutForSummaryModal] =
    React.useState(false);

  const clock_pin = props.loggedInPin;
  const invalidateOverviewCacheProp = props.invalidateOverviewCache;
  const invalidateOverviewCache = React.useCallback(() => {
    invalidateOverviewCacheProp?.();
  }, [invalidateOverviewCacheProp]);

  const [employeeCapableRoles, setEmployeeCapableRoles] = React.useState([])

  const [pendingPaidBreakPrompt, setPendingPaidBreakPrompt] = React.useState(false);
  const [showPaidBreakConfirmation, setShowPaidBreakConfirmation] = React.useState(false);
  const [paidBreakCount, setPaidBreakCount] = React.useState(0);
  const [pendingPaidBreakTimecard, setPendingPaidBreakTimecard] = React.useState(null);
  const [paidBreakConfirmationResponse, setPaidBreakConfirmationResponse] = React.useState(null);
  const [mealBreakConfirmationResponse, setMealBreakConfirmationResponse] = React.useState(null);
  const [shouldOpenSummaryAfterPaidBreak, setShouldOpenSummaryAfterPaidBreak] =
    React.useState(false);
  const [breakAttestationNote, setBreakAttestationNote] = React.useState("");
  const [paidBreaksTaken, setPaidBreaksTaken] = React.useState(true);
  const [mealBreakTaken, setMealBreakTaken] = React.useState(true);

  const scheduledPaidBreaks = React.useMemo(() => {
    const schedules = employeeClockData?.suggested_published_schedules || [];
    const currentSchedule = schedules?.[0];

    if (!currentSchedule) {
      return [];
    }

    const normalizedBreaks = normalizePaidBreaks(currentSchedule?.paid_breaks);

    return normalizedBreaks.filter(
      (paidBreak) => paidBreak.break_type === "paid_10_min"
    );
  }, [employeeClockData]);

  const breakAttestationEnabled = employeeClockData?.timecard_config?.break_attestation_enabled;
  const paidBreakTrackingEnabled = employeeClockData?.timecard_config?.paid_break_tracking_enabled;
  const enforceMinimumMealBreakDurationEnabled = employeeClockData?.timecard_config?.enforce_minimum_meal_break_duration_enabled;
  const enforceMinimumPaidBreakDurationEnabled = employeeClockData?.timecard_config?.enforce_minimum_paid_break_duration_enabled;
  const minMealBreakDurationMinutes = employeeClockData?.timecard_config?.min_break_duration_minutes ?? 30;
  const minPaidBreakDurationMinutes = employeeClockData?.timecard_config?.min_paid_break_duration_minutes ?? 10;

  useEffect(() => {
    const attestationNote =
      employeeClockData?.active_timecard?.break_attestation_note || "";
    setBreakAttestationNote(attestationNote);
  }, [employeeClockData?.active_timecard?.break_attestation_note]);

  useEffect(() => {
    const activeTimecard = employeeClockData?.active_timecard;

    // Initialize paid breaks taken
    if (activeTimecard?.paid_breaks_taken !== undefined &&
        activeTimecard?.paid_breaks_taken !== null) {
      setPaidBreaksTaken(activeTimecard.paid_breaks_taken);
    } else {
      setPaidBreaksTaken(true);
    }

    // Initialize meal break taken
    if (activeTimecard?.meal_break_taken !== undefined &&
        activeTimecard?.meal_break_taken !== null) {
      setMealBreakTaken(activeTimecard.meal_break_taken);
    } else {
      setMealBreakTaken(true);
    }
  }, [employeeClockData?.active_timecard]);

  // Process active shift with add_shift_attributes
  const processedActiveShift = React.useMemo(() => {
    const activeSchedule = employeeClockData?.active_timecard?.published_schedule;

    if (!activeSchedule) {
      return null;
    }

    // Add date and store fields
    const scheduleWithDateAndStore = {
      ...activeSchedule,
      date: activeSchedule.date || formatDate(new Date()),
      store: props.homeStoreObj
    };
    return add_shift_attributes(scheduleWithDateAndStore);
  }, [employeeClockData?.active_timecard?.published_schedule, props.homeStoreObj]);

  // Helper function to select the most appropriate shift based on current time
  const selectBestShift = (schedules) => {
    if (!schedules || schedules.length === 0) {
      return null;
    }

    // If only one shift, return it
    if (schedules.length === 1) {
      return schedules[0];
    }

    // Get current time in decimal hours (e.g., 10:30 AM = 10.5)
    const now = new Date();
    const currentHour = now.getHours() + now.getMinutes() / 60;

    // Find the best matching shift
    let bestShift = null;
    let smallestTimeDiff = Infinity;

    for (const schedule of schedules) {
      const shiftStart = schedule.shift_start;
      const shiftEnd = schedule.shift_end;

      // Check if current time is during this shift
      if (currentHour >= shiftStart && currentHour <= shiftEnd) {
        return schedule; // Found a shift that's happening now
      }

      // Calculate how close we are to this shift's start time
      const timeUntilStart = shiftStart - currentHour;

      // Prefer upcoming shifts over past shifts
      if (timeUntilStart > 0) {
        // This shift is in the future
        if (timeUntilStart < smallestTimeDiff) {
          smallestTimeDiff = timeUntilStart;
          bestShift = schedule;
        }
      } else if (bestShift === null) {
        // No future shifts found yet, so consider past shifts
        const timeSinceStart = Math.abs(timeUntilStart);
        if (timeSinceStart < smallestTimeDiff) {
          smallestTimeDiff = timeSinceStart;
          bestShift = schedule;
        }
      }
    }

    // Return the best match, or first shift if no good match found
    return bestShift || schedules[0];
  };

  // Process suggested shift with add_shift_attributes
  const processedSuggestedShift = React.useMemo(() => {
    const schedules = employeeClockData?.suggested_published_schedules;
    const suggestedSchedule = selectBestShift(schedules);
    if (!suggestedSchedule) {
      return null;
    }
    // Add date and store fields
    const scheduleWithDateAndStore = {
      ...suggestedSchedule,
      date: suggestedSchedule.date || formatDate(new Date()),
      store: props.homeStoreObj
    };
    return add_shift_attributes(scheduleWithDateAndStore);
  }, [employeeClockData?.suggested_published_schedules, props.homeStoreObj]);

  const fetchCapableRoles = async () => {
    let api_params = { store_id: props.homeStore };
    let api = API_get_capable_roles;
    try {
      const res = await getRightworkAPI(api, api_params);

      if (res.status === 200) {
        const data = res.data;
        console.log("RES", res)
        setEmployeeCapableRoles(data);
      }
    } catch (error) {
      throw Error(error);
    }
  };

  React.useEffect(() => {
    fetchCapableRoles()
  }, [])

  const roleSelectionList = employeeCapableRoles?.filter(x => x.store_team_member === props.employeeClockData?.employee?.id)
  const hasScheduledMealBreak = (shift) =>
    (shift?.break_length || 0) > 0 || (shift?.break_length_2 || 0) > 0;

  // ----------- POST APIs ----------- //

  const post_time_card_clock_in = async (
    clocked_in_at,
    published_schedule_id,
    role_id
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      clock_pin: clock_pin,
      clocked_in_at: clocked_in_at,
      published_schedule_id: published_schedule_id,
      role_id: role_id
    };

    try {
      toast.loading("Clocking In...", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
      });

      const res = await postRightworkAPI(
        API_post_timecard_clock_in,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Clocked In Successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });

        invalidateOverviewCache();

        props.get_employee_data(clock_pin);
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      } else {
        toast.error("Request Failed", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const post_time_card_clock_out = async (timecard_uuid, clocked_out_at, breakAttestationData = {}) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      clock_pin: clock_pin,
      timecard_uuid: timecard_uuid,
      clocked_out_at: clocked_out_at,
      ...breakAttestationData,
    };

    try {
      toast.loading("Clocking Out...", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
      });

      const res = await postRightworkAPI(
        API_post_timecard_clock_out,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Clocked Out Successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });

        invalidateOverviewCache();

        props.get_employee_data(clock_pin);

        // Open shift summary modal
        handleOpen();
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const post_time_card_break_start = async (timecard_uuid, clocked_in_at, is_paid) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      clock_pin: clock_pin,
      timecard_uuid: timecard_uuid,
      clocked_in_at: clocked_in_at,
      is_paid: is_paid,
    };

    try {
      const breakTypeLabel = is_paid ? "Paid Break" : "Break";
      toast.loading(`Starting ${breakTypeLabel}...`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
      });

      const res = await postRightworkAPI(
        API_post_timecard_break_clock_in,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success(`${breakTypeLabel} Started Successfully`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });

        invalidateOverviewCache();

        props.get_employee_data(clock_pin);
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const post_time_card_break_end = async (
    timecard_break_uuid,
    clocked_out_at
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      clock_pin: clock_pin,
      timecard_break_uuid: timecard_break_uuid,
      clocked_out_at: clocked_out_at,
    };

    try {
      toast.loading("Ending Break...", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
      });

      const res = await postRightworkAPI(
        API_post_timecard_break_clock_out,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Break Ended Successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });

        invalidateOverviewCache();

        props.get_employee_data(clock_pin);
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );

  const clockInTime = employeeClockData?.active_timecard?.clocked_in_at;
  const clockOutTime = employeeClockData?.active_timecard?.clocked_out_at;

  const breaksArray = [];

  employeeClockData?.active_timecard?.timecard_breaks?.forEach((breakItem) => {
    breaksArray.push({
      time: new Date(breakItem.clocked_in_at).toLocaleTimeString(),
      timeInt: breakItem.clocked_in_at,
      type: "break_start",
      text: breakItem.is_paid ? "Paid Break Started" : "Break Started",
      is_paid: breakItem.is_paid,
      clocked_in_at: breakItem.clocked_in_at,
      clocked_out_at: breakItem.clocked_out_at,
    });

    if (breakItem.clocked_out_at) {
      breaksArray.push({
        time: new Date(breakItem.clocked_out_at).toLocaleTimeString(),
        timeInt: breakItem.clocked_out_at,
        type: "break_end",
        text: breakItem.is_paid ? "Paid Break Ended" : "Break Ended",
        is_paid: breakItem.is_paid,
      });
    }
  });

  const mostRecentBreakStartTime =
    employeeClockData?.active_timecard?.timecard_breaks?.[
      employeeClockData?.active_timecard?.timecard_breaks?.length - 1
    ]?.clocked_in_at;
  const mostRecentBreakEndTime =
    employeeClockData?.active_timecard?.timecard_breaks?.[
      employeeClockData?.active_timecard?.timecard_breaks?.length - 1
    ]?.clocked_out_at;

  const [shiftTimeline, setShiftTimeline] = useState([]);

  const [isClockedIn, setIsClockedIn] = useState(
    clockInTime !== null && clockOutTime === null
  );
  const [isOnBreak, setIsOnBreak] = useState(
    mostRecentBreakStartTime !== null && mostRecentBreakEndTime === null
  );

  useEffect(() => {
    // Create a new array combining clockInTime and breaksArray
    const updatedTimeline = [
      ...(clockInTime
        ? [
            {
              time: new Date(clockInTime).toLocaleTimeString(),
              timeInt: clockInTime,
              type: "clock_in",
              text: "Clocked In",
            },
          ]
        : []),
      ...breaksArray,
      ...(clockOutTime
        ? [
            {
              time: new Date(clockOutTime).toLocaleTimeString(),
              timeInt: clockOutTime,
              type: "clock_out",
              text: "Clocked Out",
            },
          ]
        : []),
    ];

    // Set the state with the updated timeline
    setShiftTimeline(updatedTimeline);

    setIsClockedIn(clockInTime !== null && clockOutTime === null);
    setIsOnBreak(
      mostRecentBreakStartTime !== null && mostRecentBreakEndTime === null
    );
  }, [employeeClockData]);


  // console.log("SHIFT TIMELINE", shiftTimeline);
  // console.log("IS CLOCKED IN", isClockedIn);
  // console.log(clockInTime !== null)
  // console.log(clockOutTime === null)
  // console.log("IS ON BREAK", isOnBreak);

  const [currentTimeMs, setCurrentTimeMs] = React.useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
      setCurrentTimeMs(Date.now());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleClockIn = (selectedRole) => {
    const now = new Date().toLocaleTimeString();
    post_time_card_clock_in(
      Date.now(),
      processedSuggestedShift?.id ?? null,
      selectedRole
    );
    // setShiftTimeline([
    //   ...shiftTimeline,
    //   { time: now, type: "clock_in", text: "Clocked In" },
    // ]);
    // setIsClockedIn(true);
    setShowClockOutForSummaryModal(false);
    setClockOutTimeForSummaryModal(null);
    setPaidBreakConfirmationResponse(null);
    setMealBreakConfirmationResponse(null);
  };

  const handleClockOut = () => {
    const clockOutTime = Date.now();
    setClockOutTimeForSummaryModal(clockOutTime);

    // Check if break attestation is needed
    const hasPaidBreaksScheduled = scheduledPaidBreaks.length > 0;
    const hasMealBreakScheduled = hasScheduledMealBreak(
      employeeClockData?.suggested_published_schedules?.[0]
    );

    const paidBreaksNeedAttestation = hasPaidBreaksScheduled &&
      (employeeClockData?.active_timecard?.paid_breaks_taken === null ||
       employeeClockData?.active_timecard?.paid_breaks_taken === undefined);

    const mealBreakNeedsAttestation = hasMealBreakScheduled &&
      (employeeClockData?.active_timecard?.meal_break_taken === null ||
       employeeClockData?.active_timecard?.meal_break_taken === undefined);

    const attestationNeeded = breakAttestationEnabled &&
      (paidBreaksNeedAttestation || mealBreakNeedsAttestation);

    if (attestationNeeded) {
      // Show attestation modal first, don't clock out yet
      setPaidBreakCount(scheduledPaidBreaks.length);
      setPendingPaidBreakTimecard(employeeClockData?.active_timecard?.uuid);
      setShowPaidBreakConfirmation(true);
    } else {
      // No attestation needed, clock out immediately
      post_time_card_clock_out(
        employeeClockData?.active_timecard?.uuid,
        clockOutTime
      );
      setShowClockOutForSummaryModal(true);
    }
  };

  const handleStartPaidBreak = () => {
    post_time_card_break_start(
      employeeClockData?.active_timecard?.uuid,
      Date.now(),
      true
    );
  };

  const handleStartUnpaidBreak = () => {
    post_time_card_break_start(
      employeeClockData?.active_timecard?.uuid,
      Date.now(),
      false
    );
  };

  // Check if minimum meal break duration has been met
  const activeBreak = employeeClockData?.active_timecard?.timecard_breaks?.[
    employeeClockData?.active_timecard?.timecard_breaks?.length - 1
  ];

  const activeEnforcement = React.useMemo(() => {
    if (!isOnBreak) return null;
    if (activeBreak?.is_paid) {
      if (!enforceMinimumPaidBreakDurationEnabled) return null;
      return {
        kind: "paid",
        minimumLengthHours: minPaidBreakDurationMinutes / 60,
      };
    }
    if (!enforceMinimumMealBreakDurationEnabled) return null;
    return {
      kind: "meal",
      minimumLengthHours: minMealBreakDurationMinutes / 60,
    };
  }, [
    isOnBreak,
    activeBreak,
    enforceMinimumMealBreakDurationEnabled,
    enforceMinimumPaidBreakDurationEnabled,
    minMealBreakDurationMinutes,
    minPaidBreakDurationMinutes,
  ]);

  const canEndBreak = React.useMemo(() => {
    if (!activeEnforcement) return true;

    const minimumLengthHours = activeEnforcement.minimumLengthHours;
    if (!minimumLengthHours || minimumLengthHours === 0) {
      return true;
    }

    const breakStartTime = mostRecentBreakStartTime;
    if (!breakStartTime) {
      return true;
    }

    const elapsedTimeMs = currentTimeMs - breakStartTime;
    const elapsedTimeHours = elapsedTimeMs / (1000 * 60 * 60);

    return elapsedTimeHours >= minimumLengthHours;
  }, [activeEnforcement, mostRecentBreakStartTime, currentTimeMs]);

  // Calculate remaining time for break
  const remainingBreakTime = React.useMemo(() => {
    if (!activeEnforcement || canEndBreak) {
      return null;
    }

    const minimumLengthHours = activeEnforcement.minimumLengthHours;
    const breakStartTime = mostRecentBreakStartTime;

    if (!minimumLengthHours || !breakStartTime) {
      return null;
    }

    const elapsedTimeMs = currentTimeMs - breakStartTime;
    const remainingTimeMs = (minimumLengthHours * 60 * 60 * 1000) - elapsedTimeMs;
    const remainingMinutes = Math.ceil(remainingTimeMs / (1000 * 60));

    return remainingMinutes > 0 ? remainingMinutes : 0;
  }, [activeEnforcement, canEndBreak, mostRecentBreakStartTime, currentTimeMs]);

  const handleEndBreak = () => {
    if (!canEndBreak && activeEnforcement) {
      const breakLengthMinutes = Math.round(activeEnforcement.minimumLengthHours * 60);
      const breakLabel = activeEnforcement.kind === "paid" ? "paid break" : "meal break";
      toast.error(
        `You must take your full ${breakLengthMinutes}-minute ${breakLabel}. Please wait ${remainingBreakTime} more ${remainingBreakTime === 1 ? 'minute' : 'minutes'}.`,
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
        }
      );
      return;
    }

    const now = new Date().toLocaleTimeString();
    post_time_card_break_end(
      employeeClockData?.active_timecard?.timecard_breaks?.[
        employeeClockData?.active_timecard?.timecard_breaks?.length - 1
      ]?.uuid,
      Date.now()
    );
    // setShiftTimeline([
    //   ...shiftTimeline,
    //   { time: now, type: "break_end", text: "Break Ended" },
    // ]);
    // setIsOnBreak(false);
  };

  const closePaidBreakModal = () => {
    setShowPaidBreakConfirmation(false);
    setPendingPaidBreakTimecard(null);
  };

  const handleSubmitBreakAttestations = async () => {
    const hasPaidBreaks = scheduledPaidBreaks.length > 0;
    const hasMealBreak = hasScheduledMealBreak(
      employeeClockData?.suggested_published_schedules?.[0]
    );

    if (!pendingPaidBreakTimecard) {
      return;
    }

    // Prepare break attestation data
    const breakAttestationData = {};

    if (hasPaidBreaks) {
      breakAttestationData.paid_breaks_taken = paidBreaksTaken;
    }

    if (hasMealBreak) {
      breakAttestationData.meal_break_taken = mealBreakTaken;
    }

    if (breakAttestationNote && breakAttestationNote.trim()) {
      breakAttestationData.break_attestation_note = breakAttestationNote;
    }

    // Close modal and call clock out with attestation data
    closePaidBreakModal();

    // Call clock out with break attestation data
    await post_time_card_clock_out(
      pendingPaidBreakTimecard,
      clockOutTimeForSummaryModal,
      breakAttestationData
    );

    setShowClockOutForSummaryModal(true);
    setPaidBreakConfirmationResponse(hasPaidBreaks ? paidBreaksTaken : null);
    setMealBreakConfirmationResponse(hasMealBreak ? mealBreakTaken : null);
  };

  function floatToDateObject(floatHour) {
    // Split the float into hours and minutes
    const hours = Math.floor(floatHour);
    const minutes = Math.round((floatHour - hours) * 60);

    // Create a Date object and set the hours and minutes
    const timeDateObject = new Date();
    timeDateObject.setHours(hours);
    timeDateObject.setMinutes(minutes);

    return timeDateObject;
  }

  function getMillisecondsBetweenDateObjects(date1, date2) {
    // Convert dates to milliseconds and calculate the difference
    const millisecondsDiff = date2.getTime() - date1.getTime();

    return millisecondsDiff;
  }

  const [shiftEndTimeDateObject, setShiftEndTimeDateObject] = useState(
    floatToDateObject(
      employeeClockData?.active_timecard?.published_schedule?.shift_end
    )
  );
  const [clockInTimeDateObject, setClockInTimeDateObject] = useState(
    new Date(clockInTime)
  );

  useEffect(() => {
    setShiftEndTimeDateObject(
      floatToDateObject(
        employeeClockData?.active_timecard?.published_schedule?.shift_end
      )
    );
    setClockInTimeDateObject(new Date(clockInTime));
  }, [employeeClockData]);

  const differenceBetweenClockInAndShiftEnd = getMillisecondsBetweenDateObjects(
    clockInTimeDateObject,
    shiftEndTimeDateObject
  );
  const differenceBetweenCurrentTimeAndShiftEnd =
    getMillisecondsBetweenDateObjects(new Date(), shiftEndTimeDateObject);

  const progressPercent =
    ((differenceBetweenClockInAndShiftEnd -
      differenceBetweenCurrentTimeAndShiftEnd) /
      differenceBetweenClockInAndShiftEnd) *
    100;

  return (
    <>
      <div>
        <div className="h-screen bg-white p-6 relative flex flex-col justify-center items-center">
          <div className="w-content absolute top-6 left-6">
            <img
              src="https://rightworkpublic.s3.us-west-1.amazonaws.com/logo_name.png"
              alt="Rightwork Logo"
              width={250}
            />
          </div>
          <div className="absolute top-4 right-6 flex items-center space-x-4">
            <div
              className="px-10 py-3.5 rounded-full cursor-pointer"
              // onClick={() => props.logout()}
              onClick={handleOpenExitAppWarning}
            >
              <p className="text-violet-700 hover:text-violet-900 text-lg font-semibold">
                Exit App
              </p>
            </div>
            <div
              className="px-10 py-3.5 bg-violet-700 hover:bg-violet-800 rounded-xl cursor-pointer"
              onClick={() => {
                props.handleLogout();
                setClockOutTimeForSummaryModal(null);
              }}
            >
              <p className="text-white text-lg font-semibold">Logout</p>
            </div>
          </div>
          <div className="w-full flex flex-col justify-center items-center">
            <h3 className="text-slate-900 text-4xl">
              Welcome to {props.homeStoreName},{" "}
              {employeeClockData?.employee?.first_name}
            </h3>
            <p className="mt-4 text-slate-500 text-lg text-center w-[500px]">
              {isOnBreak
                ? (activeBreak?.is_paid ? "You are currently on a paid break" : "You are currently on break")
                : employeeClockData?.suggested_published_schedules?.length > 0
                ? isClockedIn
                  ? "You are currently clocked in for the shift below!"
                  : "Please clock in for your shift below"
                : isClockedIn
                ? "You are currently clocked in for an unscheduled shift!"
                : "You don't have a shift scheduled right now."}
            </p>
          </div>

          <div className="w-full flex justify-center mt-8">
            <div
              className={`w-[400px] h-[400px] flex items-center justify-center relative ${
                isOnBreak &&
                employeeClockData?.active_timecard?.published_schedule === null
                  ? (activeBreak?.is_paid ? "bg-blue-500" : "bg-orange-500")
                  : isClockedIn &&
                    employeeClockData?.active_timecard?.published_schedule ===
                      null
                  ? "bg-violet-700"
                  : "bg-slate-200 shadow-inner"
              } rounded-full`}
            >
              <div className="absolute mt-[7px]">
                <CircularProgress
                  size="400px"
                  variant="determinate"
                  value={progressPercent ? progressPercent : 0}
                  style={{ color: isOnBreak ? (activeBreak?.is_paid ? "#3b82f6" : "#f97316") : "#6d28d9" }}
                  sx={{ '& circle': { strokeLinecap: 'round' } }}
                />
              </div>
              <div className="w-[334px] h-[334px] flex flex-col items-center justify-center rounded-full bg-white shadow-lg">
                {employeeClockData?.active_timecard ? (
                  processedActiveShift ? (
                    <div>
                      <TimeClockShiftCard
                        shift={processedActiveShift}
                        location={props.homeStoreName}
                        status="Active"
                      />
                    </div>
                  ) : (
                    <div>
                      <TimeClockUnscheduledShiftCard isClockedIn={isClockedIn} />
                    </div>
                  )
                ) : processedSuggestedShift ? (
                  <div>
                    <TimeClockShiftCard
                      shift={processedSuggestedShift}
                      location={props.homeStoreName}
                      status="Inactive"
                    />
                  </div>
                ) : (
                  <div>
                    <TimeClockUnscheduledShiftCard isClockedIn={isClockedIn} />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="w-full flex justify-center mt-12">
            {!isClockedIn ? (
              <div
                className="bg-emerald-500 hover:bg-emerald-700 text-white font-bold py-5 rounded-xl w-96 flex items-center justify-center space-x-2 shadow cursor-pointer"
                onClick={props.timeEntriesRoleSelectionEnabled ? handleOpenRoleSelection : () => handleClockIn(null)}
              >
                <div>
                  <PlayArrowIcon style={{ fontSize: "30px" }} />
                </div>
                <p className="text-2xl">Clock In</p>
              </div>
            ) : !isOnBreak ? (
              <div className="flex flex-col items-center space-y-4">
                {paidBreakTrackingEnabled ? (
                  <div className="flex space-x-8">
                    <div
                      className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-5 rounded-xl w-56 flex items-center justify-center space-x-2 shadow cursor-pointer"
                      onClick={handleStartUnpaidBreak}
                    >
                      <div>
                        <PauseIcon style={{ fontSize: "30px" }} />
                      </div>
                      <p className="text-2xl">Unpaid Break</p>
                    </div>
                    <div
                      className="bg-slate-500 hover:bg-slate-600 text-white font-bold py-5 rounded-xl w-56 flex items-center justify-center space-x-2 shadow cursor-pointer"
                      onClick={handleStartPaidBreak}
                    >
                      <div>
                        <PauseIcon style={{ fontSize: "30px" }} />
                      </div>
                      <p className="text-2xl">Paid Break</p>
                    </div>
                  </div>
                ) : (
                  <div
                    className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-5 rounded-xl w-72 flex items-center justify-center space-x-2 shadow cursor-pointer"
                    onClick={handleStartUnpaidBreak}
                  >
                    <div>
                      <PauseIcon style={{ fontSize: "30px" }} />
                    </div>
                    <p className="text-2xl">Start Break</p>
                  </div>
                )}
                <div
                  className="bg-red-500 hover:bg-red-600 text-white font-bold py-5 rounded-xl w-72 flex items-center justify-center space-x-2 shadow cursor-pointer"
                  onClick={handleClockOut}
                >
                  <div>
                    <StopIcon style={{ fontSize: "30px" }} />
                  </div>
                  <p className="text-2xl">Clock Out</p>
                </div>
              </div>
            ) : (
              <div>
                <div
                  className={`${canEndBreak ? (activeBreak?.is_paid ? 'bg-blue-500 hover:bg-blue-600 cursor-pointer' : 'bg-orange-500 hover:bg-orange-600 cursor-pointer') : 'bg-gray-300 cursor-not-allowed'} text-white font-bold py-5 rounded-xl w-96 flex items-center justify-center space-x-2 shadow`}
                  onClick={canEndBreak ? handleEndBreak : undefined}
                  style={{ opacity: canEndBreak ? 1 : 0.6 }}
                >
                  <div>
                    <PlayCircleOutlineIcon style={{ fontSize: "30px" }} />
                  </div>
                  <p className="text-2xl">{activeBreak?.is_paid ? "End Paid Break" : "End Break"}</p>
                </div>
                {!canEndBreak && remainingBreakTime !== null && (
                  <p className={`${activeBreak?.is_paid ? 'text-blue-600' : 'text-orange-600'} text-sm mt-3 text-center`}>
                    {remainingBreakTime} {remainingBreakTime === 1 ? 'minute' : 'minutes'} remaining in your {activeBreak?.is_paid ? 'paid break' : 'meal break'}
                  </p>
                )}
              </div>
            )}
          </div>
          <div className="absolute bottom-6 left-6">
            <div>
              <p className="text-slate-900 text-3xl">
                {formatDateReadableWithDayOfWeekNoYear(formatDate(new Date()))}
              </p>
              <p className="text-slate-900 text-5xl mt-1.5">{currentTime}</p>
            </div>
          </div>
          <div className="absolute bottom-6 right-0 lg:hidden">
            {shiftTimeline?.length > 0 && (
              <div className="w-[155px] text-right pb-3 flex justify-end">
                <Tooltip title="Open summary">
                  <div
                    className="w-10 h-10 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-900 flex items-center justify-center cursor-pointer"
                    onClick={handleOpen}
                  >
                    <OpenInBrowserIcon />
                  </div>
                </Tooltip>
              </div>
            )}
            <div className="max-h-[550px] overflow-auto pr-6">
              {shiftTimeline.map((item, index) => (
                <div key={index}>
                  <div className="flex items-center space-x-2">
                    <p className="w-28 text-right text-slate-900 text-sm">
                      {item.time}
                    </p>
                    <div className="w-8 flex justify-center text-slate-500">
                      {item.type === "clock_in" ? (
                        <PlayArrowIcon style={{ marginBottom: "1px" }} />
                      ) : item.type === "clock_out" ? (
                        <StopIcon style={{ marginBottom: "1px" }} />
                      ) : item.type === "break_start" ? (
                        <PauseIcon style={{ marginBottom: "1px" }} />
                      ) : item.type === "break_end" ? (
                        <PlayCircleOutlineIcon
                          style={{ marginBottom: "1px" }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <p className="text-slate-900">{item.text}</p>
                      {/* <p className="text-xs text-slate-500">On time</p> */}
                    </div>
                  </div>
                  {index !== shiftTimeline.length - 1 && (
                    <div className="flex items-center space-x-2 pt-1.5 pb-1.5">
                      <div className="w-28"></div>
                      <div className="w-8 flex items-center">
                        <div className="w-4 h-8 border-r border-slate-200"></div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="absolute bottom-6 right-6 lg:block hidden">
            {shiftTimeline.length > 0 && (
              <div>
                <div className="pb-1 flex justify-end">
                  <Tooltip title="Open summary">
                    <div
                      className="w-10 h-10 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-900 flex items-center justify-center cursor-pointer"
                      onClick={handleOpen}
                    >
                      <OpenInBrowserIcon />
                    </div>
                  </Tooltip>
                </div>
                <p className="text-xl text-right">Last Action</p>
                <div className="flex items-center space-x-0.5 text-xl">
                  <div className="text-slate-500">
                    {shiftTimeline[shiftTimeline.length - 1]?.type ===
                    "clock_in" ? (
                      <PlayArrowIcon style={{ marginBottom: "1px" }} />
                    ) : shiftTimeline[shiftTimeline.length - 1]?.type ===
                      "clock_out" ? (
                      <StopIcon style={{ marginBottom: "1px" }} />
                    ) : shiftTimeline[shiftTimeline.length - 1]?.type ===
                      "break_start" ? (
                      <PauseIcon style={{ marginBottom: "1px" }} />
                    ) : shiftTimeline[shiftTimeline.length - 1]?.type ===
                      "break_end" ? (
                      <PlayCircleOutlineIcon style={{ marginBottom: "1px" }} />
                    ) : (
                      ""
                    )}
                  </div>
                  <p className="text-slate-500">
                    {shiftTimeline[shiftTimeline.length - 1]?.text} @{" "}
                    {shiftTimeline[shiftTimeline.length - 1]?.time}
                  </p>
                </div>
              </div>
            )}
          </div>
          <TimeClockShiftSummaryModal
            open={open}
            handleClose={handleClose}
            shiftDate={employeeClockData?.active_timecard?.clocked_in_at}
            shiftTimeline={shiftTimeline}
            clockInTimeInt={employeeClockData?.active_timecard?.clocked_in_at}
            clockInTime={clockInTime}
            clockOutTimeForSummaryModal={clockOutTimeForSummaryModal}
            setClockOutTimeForSummaryModal={setClockOutTimeForSummaryModal}
            showClockOutForSummaryModal={showClockOutForSummaryModal}
            setShowClockOutForSummaryModal={setShowClockOutForSummaryModal}
            breaksArray={breaksArray}
            paidBreaksScheduled={scheduledPaidBreaks.length}
            paidBreaksTaken={
              employeeClockData?.active_timecard?.paid_breaks_taken ??
              paidBreakConfirmationResponse
            }
            mealBreakScheduled={hasScheduledMealBreak(employeeClockData?.suggested_published_schedules?.[0])}
            mealBreakTaken={
              employeeClockData?.active_timecard?.meal_break_taken ??
              mealBreakConfirmationResponse
            }
          />
          <TimeClockExitAppWarningModal
            open={openExitAppWarning}
            handleClose={handleCloseExitAppWarning}
            logout={props.logout}
            handleLogout={props.handleLogout}
          />
          <TimeClockRoleSelectionModal
            open={openRoleSelection}
            handleClose={handleCloseRoleSelection}
            roleSelectionList={roleSelectionList}
            handleClockIn={handleClockIn}
          />
          <Modal
            open={showPaidBreakConfirmation}
            onClose={closePaidBreakModal}
            aria-labelledby="paid-break-modal-title"
            aria-describedby="paid-break-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                border: "2px solid #E2E8F0",
                borderRadius: "15px",
                boxShadow: 24,
                p: 4,
              }}
            >
              <div className="absolute right-2 top-2">
                <IconButton
                  className="text-gray-400 hover:text-gray-600"
                  onClick={closePaidBreakModal}
                  size="small"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>

              <div>
                <div className="mb-6 flex items-center space-x-3">
                  <CheckCircleOutlineIcon className="text-violet-600 h-8 w-8" />
                  <h3 className="text-xl font-semibold text-gray-900">
                    Break confirmation
                  </h3>
                </div>

                <p className="text-gray-700 mb-4">
                  Confirm whether you took your scheduled breaks during this shift.
                </p>

                {scheduledPaidBreaks.length > 0 && (
                  <div className="mb-4">
                    <div className="border border-slate-200 rounded-lg p-3">
                      <div className="mb-2">
                        <p className="font-semibold text-slate-800">
                          Paid break{scheduledPaidBreaks.length > 1 ? 's' : ''}
                        </p>
                        <p className="text-sm text-slate-500 mt-1">
                          Did you take your paid break{scheduledPaidBreaks.length > 1 ? 's' : ''} during this shift?
                        </p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          className={`flex-1 px-3 py-2 rounded-lg border text-sm font-medium ${
                            paidBreaksTaken === true
                              ? "border-violet-600 text-violet-700 bg-violet-50"
                              : "border-gray-200 text-gray-700 hover:bg-gray-50"
                          }`}
                          onClick={() => setPaidBreaksTaken(true)}
                        >
                          Taken
                        </button>
                        <button
                          className={`flex-1 px-3 py-2 rounded-lg border text-sm font-medium ${
                            paidBreaksTaken === false
                              ? "border-violet-600 text-violet-700 bg-violet-50"
                              : "border-gray-200 text-gray-700 hover:bg-gray-50"
                          }`}
                          onClick={() => setPaidBreaksTaken(false)}
                        >
                          Not taken
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {!breakAttestationEnabled &&
                 hasScheduledMealBreak(employeeClockData?.suggested_published_schedules?.[0]) && (
                  <div className="mb-4">
                    <div className="border border-slate-200 rounded-lg p-3">
                      <div className="mb-2">
                        <p className="font-semibold text-slate-800">Meal break</p>
                        <p className="text-sm text-slate-500 mt-1">
                          Did you take your scheduled meal break?
                        </p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          className={`flex-1 px-3 py-2 rounded-lg border text-sm font-medium ${
                            mealBreakTaken === true
                              ? "border-violet-600 text-violet-700 bg-violet-50"
                              : "border-gray-200 text-gray-700 hover:bg-gray-50"
                          }`}
                          onClick={() => setMealBreakTaken(true)}
                        >
                          Taken
                        </button>
                        <button
                          className={`flex-1 px-3 py-2 rounded-lg border text-sm font-medium ${
                            mealBreakTaken === false
                              ? "border-violet-600 text-violet-700 bg-violet-50"
                              : "border-gray-200 text-gray-700 hover:bg-gray-50"
                          }`}
                          onClick={() => setMealBreakTaken(false)}
                        >
                          Not taken
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {breakAttestationEnabled &&
                 hasScheduledMealBreak(employeeClockData?.suggested_published_schedules?.[0]) && (
                  <div className="mb-4">
                    <div className="border border-slate-200 rounded-lg p-3">
                      <div className="mb-2">
                        <p className="font-semibold text-slate-800">Meal break</p>
                        <p className="text-sm text-slate-500 mt-1">
                          Did you take your scheduled meal break?
                        </p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          className={`flex-1 px-3 py-2 rounded-lg border text-sm font-medium ${
                            mealBreakTaken === true
                              ? "border-violet-600 text-violet-700 bg-violet-50"
                              : "border-gray-200 text-gray-700 hover:bg-gray-50"
                          }`}
                          onClick={() => setMealBreakTaken(true)}
                        >
                          Taken
                        </button>
                        <button
                          className={`flex-1 px-3 py-2 rounded-lg border text-sm font-medium ${
                            mealBreakTaken === false
                              ? "border-violet-600 text-violet-700 bg-violet-50"
                              : "border-gray-200 text-gray-700 hover:bg-gray-50"
                          }`}
                          onClick={() => setMealBreakTaken(false)}
                        >
                          Not taken
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {breakAttestationEnabled && (
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Shift note (optional)
                    </label>
                    <textarea
                      className="w-full border border-gray-200 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
                      rows={3}
                      value={breakAttestationNote}
                      onChange={(event) => setBreakAttestationNote(event.target.value)}
                      placeholder="Add any additional context about your shift"
                    />
                  </div>
                )}

                <div className="flex items-center justify-end space-x-3">
                  <button
                    className="px-4 py-2.5 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors duration-200 text-sm font-medium"
                    onClick={closePaidBreakModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-2.5 rounded-lg bg-violet-600 text-white hover:bg-violet-700 transition-colors duration-200 text-sm font-medium"
                    onClick={handleSubmitBreakAttestations}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    username: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimeClockContents);
